import React, { useState } from 'react';
import './MailingAlarm.scss';
import TopicList from './components/TopicList';
import AlertLogs from './components/AlertLogs';
import AdminEmails from './components/AdminEmails';

function MailingAlarm(props) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <React.Fragment>
            <div className='mailingAlarmPage'>
                <h2 className="pageTitle">메일링 알람</h2>
                <div className="pageContent">
                    <button className="openAdminEmails" onClick={(e) => { e.preventDefault(); setIsOpen(true) }}>수신 이메일</button>
                    <div className="tablesArea">
                        <TopicList />
                        <AlertLogs />
                    </div>
                </div>
            </div>
            <AdminEmails
                isOpen={isOpen}
                onRequestClose={() => setIsOpen(false)}
                contentLabel={"알람 수신 이메일"}
            />
        </React.Fragment>
    );
}

export default MailingAlarm;